import ClientDetails from './ClientDetails'
import ContactDetails from './ContactDetails'
import FarmDetails from './FarmDetails'
import AnimalNumbers from './AnimalNumbers'
import HistoricProduction from './HistoricProduction'
import MastitisMilkQuality from './MastitisMilkQuality'
import ReproductionPlanning from './ReproductionPlanning'
import TraceElements from './TraceElements'
import WelfareMonitoring from './WelfareMonitoring'
import AnimalHealth from './AnimalHealth'
import PreventiveHealthAndVacination from './PreventiveHealthAndVacination'
import YoungStock from './YoungStock'
import Programmes from './Programmes'
import DrugAllocations from './DrugAllocations'
import EmailNotifications from './EmailNotifications'
import DrugCombinations from './DrugCombinations'
import Disclaimer from './Disclaimer'


export const winterConsultComponents = {
  ClientDetails,
  ContactDetails,
  FarmDetails,
  AnimalNumbers,
  HistoricProduction,
  MastitisMilkQuality,
  ReproductionPlanning,
  TraceElements,
  WelfareMonitoring,
  AnimalHealth,
  PreventiveHealthAndVacination,
  YoungStock,
  Programmes,
  DrugAllocations,
  EmailNotifications,
  DrugCombinations,
  Disclaimer,
}
